// Named default export
const Instruments = [
  {
    name: "Guitar",
    image: require("../images/guitar.png"),
    id: 1,
  },
  {
    name: "Drum",
    image: require("../images/drum.png"),
    id: 2,
  },
  {
    name: "Violin",
    image: require("../images/violin.png"),
    id: 3,
  },
  {
    name: "Piano",
    image: require("../images/piano.png"),
    id: 4,
  },
  {
    name: "Maracas",
    image: require("../images/maracas.png"),
    id: 5,
  },
  {
    name: "Trumpet",
    image: require("../images/trumpet.png"),
    id: 6,
  },
  {
    name: "Accordion",
    image: require("../images/accordion.png"),
    id: 7,
  },
];

const Tools = [
  {
    name: "Audio Trimer",
    image: require("../images/tools/audioTrim.jpg"),
    description:
      "Trim audio files with ease using our online tool. Edit out unwanted sections, preview changes instantly, and save in your preferred format.",
  },
  {
    name: "Sound Effects",
    image: require("../images/tools/soundEffects.jpg"),
    description:
      "Explore a world of sonic possibilities with our extensive sound effects library.",
  },
  {
    name: "Audio Trimer",
    image: require("../images/tools/audioTrim.jpg"),
    description: "",
  },
  {
    name: "Audio Trimer",
    image: require("../images/tools/audioTrim.jpg"),
    description: "",
  },
  {
    name: "Audio Trimer",
    image: require("../images/tools/audioTrim.jpg"),
    description: "",
  },
  {
    name: "Audio Trimer",
    image: require("../images/tools/audioTrim.jpg"),
    description: "",
  },
];




const dashboardData = { Instruments, Tools };

export default dashboardData;
